import { gql } from '@apollo/client';
import { SIMPLR_EXPERT_FIELDS_FRAGMENT } from '../simplrExpertFieldsFragment.gql';
import { EXPERT_QUEUE_FIELDS_FRAGMENT } from './expertQueueFieldsFragment.gql';

export const GET_SIMPLR_EXPERT_BY_ID_QUERY = gql`
  ${SIMPLR_EXPERT_FIELDS_FRAGMENT}
  query getSimplrExpertById($simplrExpertId: String!) {
    simplrExpertGet(id: $simplrExpertId) {
      ...SimplrExpertFields
      userPtr {
        objectId: id
        userRolesPolicies {
          id
          resourceNames
          partnersAllowlist
        }
      }
    }
  }
`;

export const GET_NOMINATED_EXPERT_QUEUES_QUERY = gql`
  ${EXPERT_QUEUE_FIELDS_FRAGMENT}
  query getNominatedExpertQueues($sorting: [ExpertQueueSort!], $filter: ExpertQueueFilter, $paging: CursorPaging) {
    expertQueuesFind(sorting: $sorting, filter: $filter, paging: $paging) {
      nodes {
        ...ExpertQueueFields
      }
    }
  }
`;

export const FIND_ALL_EXPERTS_QUERY = gql`
  ${SIMPLR_EXPERT_FIELDS_FRAGMENT}
  query findAllExperts($paging: CursorPaging, $filter: SimplrExpertFilter, $sorting: [SimplrExpertSort!]) {
    simplrExpertsFind(paging: $paging, filter: $filter, sorting: $sorting) {
      nodes {
        ...SimplrExpertFields
      }
      pageInfo {
        cursor: endCursor
      }
    }
  }
`;
